import React from 'react';

export default class EmptyComponent extends React.Component{
    
    render(){
        return (
            <span></span>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/components/PersonalLoan-Component/FormSteps-Component/Empty.js